/* This component is header component which is reusable 
   for all components 
   Created by: Nikhil Gaykhe
*/

import SideNav from 'LIBRARY/Header/SideNavigation/SideNav';
import React, { useEffect, useState } from 'react';
import 'LIBRARY/Header/header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import SuccessModal from "LIBRARY/CommonResources/SuccessModal/SuccessModal";
import Axios from 'axios';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import appRegistrationIcon from '../CommonResources/images/app_registrationIcon.png';
import overviewIcon from '../CommonResources/images/overviewIcon.png';
import notificationIcon from '../CommonResources/images/notificationIcon.png';
import { toast } from 'react-toastify';
import UserActivityPanel from 'LIBRARY/CommonResources/UserActivityPanel/UserActivityPanel.js';
import BookMarkModal from 'LIBRARY/CommonResources/BookmarkModal/BookMarkModal';
import NewNotificationPanel from 'LIBRARY/CommonResources/NewNotificationPanel/NotificationPanel';
import UserProfilePanel from 'LIBRARY/CommonResources/UserProfilePanel/UserProfilePanel';
import NewUserActivityPanel from 'LIBRARY/CommonResources/NewUserActivityPanel/UserActivityPanel';


const HeaderWorkspace = (props) => {
    const pointsData = config.pointsInfo;

    // VARIABLES FOR OVERDUE MESSAGE
    const [overdueCondition, setOverdueCondition] = useState('');
    const [overdueMessage, setOverdueMessage] = useState('');
    const [stepNumber, setStepNumber] = useState('');
    const [alertModal, setAlertModal] = useState(false);
    const [dueDate, setDueDate] = useState("");
    const [dateAfterSevenDays, setDateAfterSevenDays] = useState("");
    const [paymentAcceptanceObject, setPaymentAcceptanceObject] = useState({});
    const [acceptanceSequenceIdArray, setAcceptanceSequenceIdArray] = useState([]);
    const [clientSubscriptionId, setClientSubscriptionId] = useState('');
    const [installmentId, setInstallmentId] = useState('');
    const [acceptanceCount, setAcceptanceCount] = useState('');
    const [showModuleDetails, setShowModuleDetails] = useState(false);
    const [daysCount, setDaysCount] = useState("seven");
    const [acceptingExtension, setAcceptingExtension] = useState(false);

    // VARIABLES TO VIEW MODULE LIST POPOVER
    const [moduleListArray, setModuleListArray] = useState([]);
    const [temporaryModuleListArray, setTemporaryModuleListArray] = useState([]);

    // VARIABLES TO VIEW SUCCESS MODAL
    const [successModal, setSuccessModal] = useState(false);
    const [successModalType, setSuccessModalType] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [ActivityLogModal, setActivityLogModal] = useState(false);
    const [moduleListModal, setModuleListModal] = useState(false);
    const [userInfoModal, setUserInfoModal] = useState(false);
    const [notificationModal, setNotificationModal] = useState(false);
    const [subscriptionWaring, setSubscriptionWaring] = useState('');
    const [userAcceptedHTML, setUserAcceptedHTML] = useState('');

    const [unReadMessageCount, setUnReadMessageCount] = useState(0);
    const [unReadUpdateReadMessageCount, setUnReadMessageUpdateCount] = useState(0);
    const [openBookMarkModal, setOpenBookmarkModal] = useState(false);
    const [isNotificationModalUpdate, setIsNotificationModalUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    //GET TEMPLATE DATA
    const routingMenu = useSelector((state) => state.RouteMenuReducer);
    
    const dispatch = useDispatch();

    const imageExtensions = ['jpeg', 'jpg', 'png'];

    useEffect(() => {
        // Define an array of valid hash values
        const validHashValues = [
            '#/resource',
            '#/issuereturn',
            '#/periodicals',
            '#/eresources',
            '#/rules',
            '#/libraryentry',
            '#/publisher',
            '#/donorList',
            '#/printbarcode',
            '#/stockverification',
            '#/resourcecategory',
            '#/resourcelocation',
            '#/requisition',
            '#/purchaserequest',
            '#/reports',
            '#/settings',
            '#/invoice',
            '#/dashboard',
            '#/membership',
            '#/resourceDetails',
            '#/noDueCertificate',
            '#/reports/allReports'
        ];
        const knownPart = '#/resource/'

        if (window.location.hash.startsWith(knownPart)) {
            dispatch({ type: 'TOGGLE_CURRENT_VIEW', IsAdminView: true });
        }

        if (validHashValues.includes(window.location.hash)) {
            dispatch({ type: 'TOGGLE_CURRENT_VIEW', IsAdminView: true });
        }

    }, [window.location.hash, dispatch]);

    useEffect(() => {
        document.getElementById("mySidenav").style.width = "0";

        if (config.account == "faculty") {
            //API CALL TO GET MODULE LIST ARRAY
            Axios.get(`${config.RootUrl}/faculty/summary/moduleNavigation.json`).then(res => {
                setModuleListArray(res.data);
                setTemporaryModuleListArray(res.data);
            });
        } else {
            //API CALL TO GET MODULE LIST ARRAY
            Axios.get(`${config.RootUrl}/student/learnerModuleNavigation.json`).then(res => {
                setModuleListArray(res.data);
                setTemporaryModuleListArray(res.data);
            });
        }

        // METHOD CALLED TO GET OVERDUE
        apiCallToGetOverdueDetails();
        apiCallToGetWebNotification();
        apiCallToGetUpdateDetails();
    }, []);


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key === ' ') {
                handleModalOpenClose('moduleList')
            }

            if (event.key === 'Escape') {
                handleEscapeKey();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        apiCallToGetWebNotification();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notificationModal])

    //  API CALL TO GET NOTIFICATION
    const apiCallToGetWebNotification = async () => {
        setIsLoading(true);
        let formData = {
            iid: config.institute_id,
            userRole: config.account == "faculty" || config.account == "instructor" || config.account == "employee" || config.account == "teaching" || config.instructorInfo.account == "nonteaching" ? "instructor" : "learner",
            userId: config.faculty_id,
            offset: 1,
            limit: 10,
            iidArray: Object.values(routingMenu?.assignedInstitute).map((item) => item.iid)
        };
        let jsonResponse = await LibraryApiCall.makeApiCall(
            "webNotificationGetNotification",
            formData,
            '/api/webNotification/webNotification.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetWebNotification();
            }, 1000);
        } else {
            if (jsonResponse.success) {


                let unReadMessageCount = Number(jsonResponse.APIResult.unReadMessageCount);

                setUnReadMessageCount(unReadMessageCount);

                setIsLoading(false);
            } else {
                setIsLoading(false);
            }
        }
    }

    //  API CALL TO GET UPDATES
    const apiCallToGetUpdateDetails = async () => {
        const requestData = {
            userId: config.faculty_id,
            iid: config.institute_id,
        };
        try {
            const jsonResponse = await LibraryApiCall.makeAPICall(
                'pmTool_getSummaryNotificationCount',
                requestData,
                "/api/projectManagement/Queries/pmTool_DocSEMDashBoard.php"
            );
            if (jsonResponse.expired) {
                setTimeout(() => {
                    apiCallToGetUpdateDetails();
                }, 1000);
            } else {
                if (jsonResponse.success) {

                    let updateReadUnCount = Number(jsonResponse.APIResult.unreadNotificationCount);


                    setUnReadMessageUpdateCount(updateReadUnCount);




                } else {
                    toast.error("Something went wrong While getting Announcements")
                }
            }
        }
        catch (error) {
            // toast.error('Something went wrong While getting Announcements:', error);
        }
    };

    const notificationUpdates = () => {
        setIsNotificationModalUpdate(!isNotificationModalUpdate);
    }

    const closeBookMark = () => {
        setOpenBookmarkModal(false);
    }

    // API CALL METHOD TO GET OVERDUE DETAILS
    const apiCallToGetOverdueDetails = async () => {
        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id,
            "iidArray": Object.keys(routingMenu.assignedInstitute)
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetHelpDeskPendingInstallmentDueDateMessage',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetOverdueDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let alertModal = false;
                let stepNumber = jsonResponse.APIResult.stepNumber;

                if (!(stepNumber == 0 && apiResult.acceptanceSequenceIdArray.length == 0)) {
                    document.getElementById("routeSetup").style.paddingTop = "28px";
                } else {
                    document.getElementById("routeSetup").style.paddingTop = "0px";
                }

                if (stepNumber > 3) {
                    alertModal = true;
                }

                if ((stepNumber == 4 && apiResult.acceptanceSequenceIdArray.length == 1) || (stepNumber == 5 && apiResult.acceptanceSequenceIdArray.length == 2) || (stepNumber == 6 && apiResult.acceptanceSequenceIdArray.length == 3)) {
                    alertModal = false;
                }

                let acceptanceCount = apiResult.acceptanceSequenceIdArray.length + 1;

                setOverdueCondition(apiResult.status);
                setOverdueMessage(apiResult.message);
                setDueDate(apiResult.dueDate);
                setDateAfterSevenDays(apiResult.dateAfterSevenDays);
                setPaymentAcceptanceObject(apiResult.paymentAcceptanceObj);
                setAcceptanceSequenceIdArray(apiResult.acceptanceSequenceIdArray);
                setClientSubscriptionId(apiResult.clientSubscriptionId);
                setDaysCount(apiResult.daysCount);
                setInstallmentId(apiResult.installmentId);
                setStepNumber(stepNumber);
                setAlertModal(alertModal);
                setAcceptanceCount(acceptanceCount);
            }
        }
    }

    //METHOD TO ACCEPT SUBSCRIPTION EXTENSION
    const apiCallToAcceptExtension = async () => {
        setAcceptingExtension(true);

        let acceptanceCount = acceptanceSequenceIdArray.length + 1;

        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id,
            "clientSubscriptionId": clientSubscriptionId,
            "installmentId": installmentId,
            "acceptanceCount": acceptanceCount,
            "dueDate": dueDate,
            "dateAfterSevenDays": dateAfterSevenDays,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'AddHelpDeskInstallmentAcceptanceDetails',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToAcceptExtension();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                setAcceptingExtension(false);

                if (apiResult.status == "success") {
                    setAlertModal(false);
                    setAcceptanceCount(acceptanceCount);
                    setShowModuleDetails(true);
                    setSuccessModal(true);
                    setSuccessModalType('success');
                    setSuccessMessage(apiResult.message);
                }
            }
        }
    }

    // METHOD TO RETURN SUCCESS MODAL FOR TRANSITION / TRANSFER QUERY
    // const returnSubscriptionAlertModal = () => {
    //     return (
    //         <div className={alertModal ? "modal fade show" : "modal fade"} id="modalContainer" >
    //             <div className="modal-dialog modal-dialog-centered modal-lg">
    //                 <div className="modal-content">
    //                     <div className="modal-body SubscriptionAlertModal-body">
    //                         <div style={{ display: "flex", flexDirection: "column-reverse", alignItems: "flex-end" }} className="col-md-12">
    //                             <a className="" style={{ cursor: 'pointer' }} href={`${config.RootUrl}/vmlogout.php?url=${config.instituteUrl}`} onClick={() => userSignOut()}>
    //                                 Log Out
    //                             </a>
    //                         </div>
    //                         <div className="step4">
    //                             <div className="col-md-10">
    //                                 {
    //                                     ReactHtmlParser(subscriptionWaring)
    //                                 }
    //                             </div>
    //                             <div className="col-md-2 ">
    //                                 <div className="warningIconContainer">
    //                                     <FontAwesomeIcon
    //                                         className="warningicon"
    //                                         icon={["fas", "exclamation-triangle"]}
    //                                         size="lg"
    //                                         color="#F44336"
    //                                     />
    //                                 </div>
    //                             </div>
    //                         </div>
    //                         {
    //                             ReactHtmlParser(userAcceptedHTML)
    //                         }


    //                         {
    //                             stepNumber == 3 ?
    //                                 <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
    //                                     <button className="btn outline-button backQueryButton" style={{ textTransform: 'none', cursor: 'Pointer' }} onClick={() => setAlertModal(false)}>
    //                                         Close
    //                                     </button>
    //                                 </div>
    //                                 :
    //                                 (stepNumber == 4 || stepNumber == 5 || stepNumber == 6) &&
    //                                 <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
    //                                     <button className="btn btn-outline-primary waves-effect" style={{ textTransform: 'none' }} >
    //                                         <a href={config.RootUrl + '/modules/myworkspace/#/'} style={{ textTransform: 'none', color: "#0465ac" }}>
    //                                             Go To Summary
    //                                         </a>
    //                                     </button>
    //                                 </div>
    //                         }
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }

    // // HANDLE FILTER BY CATEGORY
    // const handleFilterByCategory = (e) => {
    //     let checkedValues = checkedValue;

    //     if (checkedValues.includes(e.target.value)) {
    //         checkedValues = checkedValues.filter(name => name != e.target.value);
    //     } else {
    //         checkedValues.push(e.target.value);
    //     }

    //     setCheckedValue(checkedValues);

    //     handleFilterByCategoryResponse(checkedValues);
    // }

    // // HANDLE FILTER BY CATEGORY RESPONSE
    // const handleFilterByCategoryResponse = (checkedValues) => {
    //     let checkedFilterArray = [];

    //     temporaryModuleListArray.map((module_type) => {
    //         let isChecked = false;
    //         for (let i = 0; i < checkedValues.length; i++) {
    //             if (module_type.moduleType.includes(checkedValues[i])) {
    //                 isChecked = true;
    //             }
    //         }

    //         if (isChecked) {
    //             checkedFilterArray.push(module_type);
    //         }
    //     });

    //     if (checkedValues.length == 0) {
    //         setModuleListArray(temporaryModuleListArray);
    //     } else {
    //         setModuleListArray(checkedFilterArray);
    //     }
    // }

    // METHOD TO OPEN SIDE NAVIGATION MENU
    const openNav = () => {
        document.getElementById("mySidenav").style.width = "350px";
    }

    const userSignOut = () => {
        localStorage.setItem("logout-event", Date.now());
        props.history.push(`${config.RootUrl}/vmlogout.php`);
    }

    if (config.institute_name === '' || config.institute_name === undefined) {
        config.institute_name = 'vmedulife';
    }
    //handleModalOpenClose
    const handleModalOpenClose = (modalName) => {

        // if (modalName == "moduleList") {
        //     setModuleListModal(!moduleListModal);
        //     setUserInfoModal(false);
        //     setActivityLogModal(false);
        //     setNotificationModal(false);
        //     setOpenBookmarkModal(false);
        // }
        if (modalName == "userInfo") {
            setUserInfoModal(!userInfoModal);
            setModuleListModal(false);
            setActivityLogModal(false);
            setNotificationModal(false);
            setOpenBookmarkModal(false);

        }
        if (modalName == "notification") {
            setModuleListModal(false);
            setUserInfoModal(false);
            setActivityLogModal(false);
            setNotificationModal(!notificationModal);
            setOpenBookmarkModal(false);

        }
        if (modalName == "userActivity") {
            setModuleListModal(false);
            setUserInfoModal(false);
            setActivityLogModal(!ActivityLogModal);
            setNotificationModal(false);
            setOpenBookmarkModal(false);

        }
        if (modalName == "bookmarkModal") {
            setOpenBookmarkModal(!openBookMarkModal);

            setModuleListModal(false);
            setUserInfoModal(false);
            setActivityLogModal(false);
            setNotificationModal(false);
        }
    }

    const handleEscapeKey = () => {
        setModuleListModal(false);
        setUserInfoModal(false);
        setActivityLogModal(false);
        setNotificationModal(false);
    }


    return (
        <>
            <div id="header">
                <nav className="navbar navbar-expand-lg navbar-dark">
                    <div className="college-name">
                        <button className="sidenav-button btn btn-link text-white" style={{ fontSize: 16 }} type="button" onClick={(e) => config.account == 'faculty' ? (routingMenu.isSideMenuNavigation ? openNav() : (routingMenu.expandRouteMenu ? dispatch({ type: 'TOGGLE_ROUTE_MENU', toggleFlag: false }) : dispatch({ type: 'TOGGLE_ROUTE_MENU', toggleFlag: true }))) : openNav()}>
                            <FontAwesomeIcon icon={['fas', 'bars']} size="lg" style={{ fontSize: 20 }} />
                        </button>
                        <a href={config.account == "faculty" ? config.RootUrl + '/modules/myworkspace/#/' : config.RootUrl + '/modules/studentsummary/#'}>
                            <p className="college text-white">{ReactHtmlParser(config.institute_name)}</p>
                        </a>
                    </div>
                    <div className="workspaceHeader" style={{ color: '#FFFFFF', cursor: 'pointer' }}>
                        {
                            config.account == "faculty" &&
                            (
                                (routingMenu.accessDetails == true || routingMenu.isLibraryAdmin) &&
                                <button
                                    style={{ fontSize: "13px", color: '#0465ac' }}
                                    className='mr-3 px-3 rounded-pill border-0 shadow-sm bg-white text-primary-c bold fs-13 cursor-pointer'
                                    onClick={() => {

                                        dispatch({ type: 'TOGGLE_CURRENT_VIEW', IsAdminView: !routingMenu.IsAdminView })
                                        if (window.location.origin != 'http://localhost:3000/#/' && !routingMenu.IsAdminView) {

                                            window.open(config.RootUrl + "/modules/library/#/dashboard", "_self");
                                        }
                                        else {
                                            window.open(config.RootUrl + "/modules/library/#/", "_self");
                                        }

                                    }}
                                    title={
                                        routingMenu.IsAdminView
                                            ? 'Switch back to Admin View'
                                            : 'Switch to user View'
                                    }
                                >

                                    <span className='screen-switch-text'>
                                        {
                                            routingMenu.IsAdminView
                                                ? 'Switch to user View'
                                                : 'Switch to admin View'
                                        }
                                    </span>
                                </button>
                            )
                        }

                        <span className={`dropdown mr-2 header-icon-bg ${userInfoModal ? 'ws-vm-header-icon-bg-color' : ''}`} style={{ borderRadius: '20px', padding: '2px' }}>
                            <div
                                style={{ display: 'flex', padding: '6px 10px 6px 4px', flexDirection: 'row', gap: '8px', height: '30px', border: '1px solid #18191B', borderRadius: '20px', backgroundColor: '#FFFFFF', color: '#000000', alignItems: 'center' }}
                                onClick={() => handleModalOpenClose('userInfo')}
                            >

                                {
                                    imageExtensions.includes(config.userPic.substring(config.userPic.lastIndexOf('.') + 1)) ?
                                        <img alt='config.userPic' src={config.userPic} className="admin" style={{ cursor: 'pointer', height: '20px', width: '20px' }}

                                        />
                                        :
                                        <FontAwesomeIcon
                                            icon={['fas', 'user-circle']}
                                            size="lg"
                                            className='ws-lock-subscription-color'
                                            style={{ fontSize: 30, height: '20px', width: '20px', cursor: 'pointer' }}

                                        />
                                }
                                <span
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        cursor: 'pointer',
                                        padding: '3px',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <p className='vm_custom_body18' style={{ margin: 0, padding: 0 }}>{pointsData}</p>
                                    <p className='vm_custom_body17' style={{ margin: 0, padding: 0 }}>Points</p>
                                </span>
                            </div>
                        </span>

                        <span className="vl"></span>

                        {config.account == 'faculty' &&
                            <div className={`header-icon-bg ${openBookMarkModal ? 'ws-vm-header-icon-bg-color' : ''}`} onClick={() => handleModalOpenClose('bookmarkModal')} style={{ position: "relative", borderRadius: '8px', padding: '4px' }}>
                                <span className="material-symbols-rounded"

                                // style={{ fontSize: 21, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",color: 'white' }}
                                >
                                    <img src={appRegistrationIcon} alt="app_registrationIcon" style={{ width: '21px', height: '21px', cursor: "pointer", alignItems: "center", justifyContent: "center" }} />
                                </span>
                            </div>
                        }

                        <div onClick={() => handleModalOpenClose('userActivity')} className='header-icon-bg mobileViewUserActivity' style={{ position: "relative", borderRadius: '8px', padding: '4px' }}>
                            <span className="material-symbols-rounded"
                            // style={{ fontSize: 21, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",color: 'white'  }
                            >
                                <img src={overviewIcon} alt="overviewIcon" style={{ width: '21px', height: '21px', cursor: "pointer", alignItems: "center", justifyContent: "center" }} />
                            </span>

                        </div>

                        <div onClick={() => { handleModalOpenClose('notification'); }} className='header-icon-bg mobileViewNotificationActivity' style={{ position: "relative", borderRadius: '8px', padding: '4px' }}>
                            {
                                <span
                                    className="position-absolute d-flex justify-content-center align-items-center shadow-sm "
                                    style={{ borderRadius: '50%', width: '18px', height: '18px', top: '-5px', left: '10px', fontSize: '10px', backgroundColor: '#ff0000', color: 'white' }}
                                >
                                    {
                                        (Number(unReadMessageCount) + Number(unReadUpdateReadMessageCount)) < 99 ? (Number(unReadMessageCount) + Number(unReadUpdateReadMessageCount)) : "99+"
                                    }

                                </span>
                            }

                            <span className="material-symbols-rounded"
                                style={{ fontSize: 21, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: 'white' }}>
                                <img src={notificationIcon} alt="overviewIcon" style={{ width: '21px', height: '21px', cursor: "pointer", alignItems: "center", justifyContent: "center" }} />

                            </span>

                        </div>

                    </div>

                </nav>
            </div>
            {/* <div className="subscriptionStrip" style={{ backgroundColor: (stepNumber > 1 || acceptanceCount > 1) ? '#EB5757' : stepNumber == 1 ? '#FF7800' : 'transparent', paddingTop: !(stepNumber >= 1 || acceptanceCount > 1) ? 50 : 5, paddingBottom: !(stepNumber >= 1 || acceptanceCount > 1) ? 0 : 2, height: !(stepNumber >= 1 || acceptanceCount > 1) ? 0 : 'auto', zIndex: !(stepNumber >= 1 || acceptanceCount > 1) ? -1 : 19 }}>{overdueMessage}</div> */}
            <SideNav />

            {config.account == 'faculty' && openBookMarkModal && <BookMarkModal openBookMarkModal={openBookMarkModal} handleClose={() => closeBookMark()} />}

            {
                ActivityLogModal && <NewUserActivityPanel ActivityLogModal={ActivityLogModal} handleModalOpenClose={handleModalOpenClose} />
            }
            {
                notificationModal && <NewNotificationPanel notificationUpdates={notificationUpdates} notificationModal={notificationModal} handleModalOpenClose={handleModalOpenClose} />
            }
            {
                userInfoModal && <UserProfilePanel userInfoModal={userInfoModal} handleModalOpenClose={handleModalOpenClose} />
            }

            {/* {
                returnSubscriptionAlertModal()
            } */}

            {
                successModal &&
                <SuccessModal
                    successModal={successModal}
                    successModalType={successModalType}
                    successMessage={successMessage}
                    closeSuccessModal={setSuccessModal(false)}
                />
            }
        </>
    );
}

export default HeaderWorkspace;